/* Studio VormVezel – gedrag voor de zakelijke pagina's (templates page.zakelijk, page.zakelijk-aanvragen, page.zakelijk-account).
   Geen afhankelijkheden; gebruikt window.vv uit vv.js (announce, money, addToCart, refreshCart) als die er is.
   - form[data-bz-loc]          locatie wisselen (Shopify B2B: company_location.url_to_set_as_current)
   - form[data-bz-apply]        aanvraagformulier (kort of lang): controle per veld, foutoverzicht met links in de volgorde
                                van het formulier, velden per land
   - .qol[data-bz-qo]           snel bestellen: aantallen volgens de aantalregels van Shopify, alles in één keer toevoegen
   - [data-bz-reorder]          bestelling opnieuw in de winkelwagen zetten
   - [data-bz-done]             bedankmelding na verzenden: focus op de kop */
(function () {
  'use strict';
  var D = document;
  function $(s, r) { return (r || D).querySelector(s); }
  function $$(s, r) { return Array.prototype.slice.call((r || D).querySelectorAll(s)); }
  var reduced = false;
  try { reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches; } catch (e) {}
  function announce(t) {
    if (window.vv && window.vv.announce) { window.vv.announce(t); return; }
    var l = D.getElementById('vv-live'); if (!l) return; l.textContent = ''; setTimeout(function () { l.textContent = t; }, 40);
  }
  function money(c) { return (window.vv && window.vv.money) ? window.vv.money(c) : '€' + (c / 100).toFixed(2).replace('.', ','); }
  function fill(t, map) { return String(t || '').replace(/\{(\w+)\}/g, function (m, k) { return Object.prototype.hasOwnProperty.call(map, k) ? map[k] : m; }); }
  function root() { return (window.Shopify && Shopify.routes && Shopify.routes.root) || '/'; }
  function addToCart(items) {
    if (window.vv && window.vv.addToCart) return window.vv.addToCart(items, true);
    return fetch(root() + 'cart/add.js', {
      method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: items })
    }).then(function (r) { return r.json().then(function (j) { if (!r.ok) throw j; return j; }); });
  }
  function errText(err, fallback) { return (err && (err.description || err.message)) || fallback; }

  /* ---------- Locatie wisselen ---------- */
  function goLoc(f) {
    var s = f.querySelector('select'), o = s && s.options[s.selectedIndex];
    if (!o || o.hasAttribute('data-current')) return;
    var u = o.getAttribute('data-url'); if (u) location.href = u;
  }
  D.addEventListener('submit', function (e) {
    var f = e.target; if (!f.matches || !f.matches('form[data-bz-loc]')) return;
    e.preventDefault(); goLoc(f);
  });
  /* Zonder knop (knoptekst leeg in de editor): direct wisselen bij het kiezen */
  D.addEventListener('change', function (e) {
    var s = e.target; if (!s.matches || !s.matches('form[data-bz-loc] select')) return;
    var f = s.form; if (!f || f.querySelector('[type="submit"]')) return;
    goLoc(f);
  });

  /* ---------- Aanvraagformulier ---------- */
  var EMAIL = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/;
  var ORDER = ['naam', 'type', 'kvk', 'btw', 'web', 'factuur', 'contact', 'email', 'tel', 'straat', 'postcode', 'plaats', 'aflever', 'afname', 'akkoord'];
  function initApply(f) {
    if (f._bz) return; f._bz = true;
    f.setAttribute('novalidate', '');
    /* Volgorde van de velden zoals ze in het formulier staan (kort en lang formulier verschillen) */
    var seen = {};
    var order = $$('[data-bz-field]', f).map(function (x) { return x.getAttribute('data-bz-field'); })
      .filter(function (k) { if (k === 'land' || seen[k]) return false; seen[k] = true; return true; });
    ORDER.forEach(function (k) { if (!seen[k]) order.push(k); });
    function fld(k) { return f.querySelector('[data-bz-field="' + k + '"]'); }
    function errEl(k) { return f.querySelector('[data-bz-err="' + k + '"]'); }
    function val(k) { var x = fld(k); if (!x) return null; return x.type === 'checkbox' ? (x.checked ? 'ja' : '') : String(x.value || '').trim(); }
    var land = fld('land'), sum = f.querySelector('[data-bz-errsum]');
    function opt() { return land ? land.options[land.selectedIndex] : null; }
    function ld(k) { var o = opt(); return o ? (o.getAttribute('data-' + k) || '') : ''; }
    function code() { return (ld('code') || 'NL').toUpperCase(); }
    function setErr(k, msg) {
      var e = errEl(k), x = fld(k);
      if (e) { e.textContent = msg || ''; e.hidden = !msg; }
      if (x) { if (msg) x.setAttribute('aria-invalid', 'true'); else x.removeAttribute('aria-invalid'); }
    }
    function landHint() {
      if (!land) return;
      var l = f.querySelector('[data-bz-kvk-label]'), kh = f.querySelector('[data-bz-kvk-hint]'), bh = f.querySelector('[data-bz-btw-hint]'), pc = fld('postcode'), kvk = fld('kvk');
      if (l && ld('kvk')) l.textContent = ld('kvk');
      if (kh) kh.textContent = ld('kh');
      if (bh && ld('bh')) bh.textContent = ld('bh');
      if (pc) { if (ld('pc')) pc.placeholder = ld('pc'); else pc.removeAttribute('placeholder'); }
      if (kvk) { kvk.setAttribute('inputmode', (code() === 'NL' || code() === 'BE') ? 'numeric' : 'text'); if (ld('ke')) kvk.setAttribute('data-req', ld('ke')); }
    }
    function req(k) { var x = fld(k); return (x && x.getAttribute('data-req')) || ''; }
    function bad(k) { var x = fld(k); return (x && x.getAttribute('data-bad')) || req(k); }
    function validate() {
      var c = code(), e = {}, v;
      ['naam', 'type', 'contact', 'straat', 'plaats', 'afname', 'akkoord'].forEach(function (k) { if (fld(k) && !val(k)) e[k] = req(k); });
      if (fld('kvk')) {
        v = val('kvk').replace(/[\s.]/g, '');
        if (!v) e.kvk = ld('ke') || req('kvk');
        else if (c === 'NL' && !/^\d{8}$/.test(v)) e.kvk = ld('kbad') || req('kvk');
        else if (c === 'BE' && !/^\d{10}$/.test(v)) e.kvk = ld('kbad') || req('kvk');
        else if (c !== 'NL' && c !== 'BE' && !/^[A-Za-z0-9]{4,20}$/.test(v)) e.kvk = ld('kbad') || req('kvk');
      }
      if (fld('btw')) {
        v = val('btw').replace(/[\s.\-]/g, '').toUpperCase();
        if (!v) e.btw = req('btw');
        else if (c === 'NL' && !/^NL\d{9}B\d{2}$/.test(v)) e.btw = ld('bbad') || req('btw');
        else if (c === 'BE' && !/^BE\d{10}$/.test(v)) e.btw = ld('bbad') || req('btw');
        else if (c === 'DE' && !/^DE\d{9}$/.test(v)) e.btw = ld('bbad') || req('btw');
        else if (!/^[A-Z]{2}[0-9A-Z]{8,12}$/.test(v)) e.btw = ld('bbad') || req('btw');
      }
      if (fld('email')) { v = val('email'); if (!v) e.email = req('email'); else if (!EMAIL.test(v)) e.email = bad('email'); }
      /* Telefoon: verplicht als het veld required heeft (lang formulier, instelling "Telefoon verplicht"), anders alleen controleren als hij is ingevuld */
      if (fld('tel')) { v = val('tel'); if (!v) { if (fld('tel').required) e.tel = req('tel'); } else { var dg = v.replace(/\D/g, ''); if (!/^[+()\d\s-]+$/.test(v) || dg.length < 8 || dg.length > 15) e.tel = bad('tel'); } }
      if (fld('factuur')) { v = val('factuur'); if (v && !EMAIL.test(v)) e.factuur = bad('factuur'); }
      if (fld('postcode')) {
        v = val('postcode');
        if (!v) e.postcode = req('postcode');
        else if (c === 'NL' && !/^\d{4}\s?[A-Za-z]{2}$/.test(v)) e.postcode = ld('pbad') || req('postcode');
        else if (c === 'BE' && !/^\d{4}$/.test(v)) e.postcode = ld('pbad') || req('postcode');
        else if (c === 'DE' && !/^\d{5}$/.test(v)) e.postcode = ld('pbad') || req('postcode');
      }
      return e;
    }
    function sumHTML(list) {
      var n = list.length, h = n === 1 ? (f.getAttribute('data-sum-one') || '') : fill(f.getAttribute('data-sum-many') || '', { n: n });
      var p = D.createElement('p'), b = D.createElement('b'), ul = D.createElement('ul');
      b.textContent = h; p.appendChild(b);
      list.forEach(function (it) {
        var li = D.createElement('li'), btn = D.createElement('button');
        btn.type = 'button'; btn.className = 'link-btn'; btn.setAttribute('data-bzfocus', it.id); btn.textContent = it.msg;
        li.appendChild(btn); ul.appendChild(li);
      });
      sum.innerHTML = ''; sum.appendChild(p); sum.appendChild(ul);
    }
    function current() {
      return order.map(function (k) { var e = errEl(k), x = fld(k); return (e && !e.hidden && x) ? { id: x.id, msg: e.textContent } : null; }).filter(Boolean);
    }
    function sumRefresh() {
      if (!sum || sum.hidden) return;
      var list = current();
      if (!list.length) { sum.hidden = true; sum.innerHTML = ''; return; }
      sumHTML(list);
    }
    f.addEventListener('submit', function (ev) {
      var e = validate(), list = [];
      order.forEach(function (k) { setErr(k, e[k]); if (e[k] && fld(k)) list.push({ id: fld(k).id, msg: e[k] }); });
      if (list.length) {
        ev.preventDefault();
        if (sum) { sumHTML(list); sum.hidden = false; }
        var first = D.getElementById(list[0].id); if (first) first.focus();
        announce((sum ? sum.querySelector('b').textContent + ' ' : '') + list[0].msg);
        return;
      }
      if (sum) { sum.hidden = true; sum.innerHTML = ''; }
      var b = f.querySelector('[data-bz-submit]');
      if (b) { setTimeout(function () { b.disabled = true; b.classList.add('loading'); }, 0); }
    });
    f.addEventListener('input', function (ev) {
      var k = ev.target.getAttribute && ev.target.getAttribute('data-bz-field');
      if (k && k !== 'land') { setErr(k, ''); sumRefresh(); }
    });
    f.addEventListener('change', function (ev) {
      var k = ev.target.getAttribute && ev.target.getAttribute('data-bz-field');
      if (k === 'land') { landHint(); setErr('postcode', ''); setErr('kvk', ''); setErr('btw', ''); sumRefresh(); }
      else if (k === 'akkoord' || k === 'type' || k === 'afname') { setErr(k, ''); sumRefresh(); }
    });
    f.addEventListener('click', function (ev) {
      var b = ev.target.closest && ev.target.closest('[data-bzfocus]'); if (!b) return;
      var x = D.getElementById(b.getAttribute('data-bzfocus')); if (x) x.focus();
    });
    landHint();
    /* Fout van Shopify na verzenden (bijv. e-mailadres): foutoverzicht in beeld, focus erop en voorlezen */
    if (sum && !sum.hidden) {
      sum.scrollIntoView({ block: 'center', behavior: reduced ? 'auto' : 'smooth' });
      sum.focus({ preventScroll: true });
      announce(String(sum.textContent || '').replace(/\s+/g, ' ').trim());
    }
  }
  /* Terug naar de pagina met de knop Vorige (bfcache): verzendknop weer bruikbaar maken */
  window.addEventListener('pageshow', function (e) {
    if (!e.persisted) return;
    $$('form[data-bz-apply] [data-bz-submit]').forEach(function (b) { b.disabled = false; b.classList.remove('loading'); });
  });

  /* ---------- Bedankmelding ---------- */
  function initDone(d) {
    if (d._bz) return; d._bz = true;
    var h = d.querySelector('[data-bz-done-h]') || d;
    d.scrollIntoView({ block: 'center', behavior: reduced ? 'auto' : 'smooth' });
    if (h.focus) h.focus({ preventScroll: true });
  }

  /* ---------- Snel bestellen ---------- */
  function num(el, k, d) { var v = parseInt(el.getAttribute(k), 10); return isNaN(v) ? d : v; }
  function rowInfo(row) {
    var br = (row.getAttribute('data-breaks') || '').split(',').filter(Boolean).map(function (x) { var a = x.split(':'); return { q: parseInt(a[0], 10) || 0, p: parseInt(a[1], 10) || 0 }; })
      .sort(function (a, b) { return a.q - b.q; });
    return {
      id: num(row, 'data-id', 0), price: num(row, 'data-price', 0), min: Math.max(1, num(row, 'data-min', 1)),
      inc: Math.max(1, num(row, 'data-inc', 1)), max: num(row, 'data-max', 0), cart: num(row, 'data-cart', 0), breaks: br
    };
  }
  function unitFor(info, total) { var p = info.price; info.breaks.forEach(function (b) { if (total >= b.q) p = b.p; }); return p; }
  /* Gewenst extra aantal -> geldig extra aantal (totaal in de winkelwagen volgt minimum, stapgrootte en maximum) */
  function normalize(info, want, qo) {
    var q = Math.max(0, Math.floor(+want || 0)), msg = '';
    if (!q) return { q: 0, msg: '' };
    var c = info.cart, t = c + q;
    if (t < info.min) { t = info.min; msg = fill(qo.getAttribute('data-adj-min'), { min: info.min, n: t - c }); }
    if (info.inc > 1 && t % info.inc) {
      var down = Math.floor(t / info.inc) * info.inc;
      t = (down > c && down >= info.min) ? down : down + info.inc;
      msg = fill(qo.getAttribute('data-adj-step'), { stap: info.inc, n: t - c });
    }
    if (info.max && t > info.max) {
      t = Math.floor(info.max / info.inc) * info.inc;
      msg = fill(qo.getAttribute('data-adj-max'), { max: info.max, n: Math.max(0, t - c) });
    }
    q = Math.max(0, t - c);
    return { q: q, msg: msg };
  }
  function nextUp(info, q) { return (info.cart + q < info.min) ? info.min - info.cart : q + info.inc; }
  function syncQo(qo) {
    var n = 0, sub = 0;
    $$('[data-bz-row]', qo).forEach(function (row) {
      var info = rowInfo(row), inp = row.querySelector('.qol-qty'), q = Math.max(0, parseInt(inp && inp.value, 10) || 0);
      var mi = row.querySelector('[data-bzstep="-1"]'), pl = row.querySelector('[data-bzstep="1"]');
      if (mi) { if (q) mi.removeAttribute('aria-disabled'); else mi.setAttribute('aria-disabled', 'true'); }
      if (pl) { if (normalize(info, nextUp(info, q), qo).q > q) pl.removeAttribute('aria-disabled'); else pl.setAttribute('aria-disabled', 'true'); }
      var lt = q ? unitFor(info, info.cart + q) * q : 0, t = row.querySelector('[data-bzt]');
      if (t) t.textContent = q ? money(lt) : '';
      n += q; sub += lt;
    });
    var nn = qo.querySelector('[data-bz-n]'), ss = qo.querySelector('[data-bz-sub]'), add = qo.querySelector('[data-bz-addall]');
    if (nn) nn.textContent = n ? (n === 1 ? qo.getAttribute('data-one') : fill(qo.getAttribute('data-many'), { n: n })) : qo.getAttribute('data-none');
    if (ss) ss.textContent = n ? money(sub) : '';
    if (add && !add.classList.contains('loading')) add.disabled = !n;
  }
  function setRow(row, want, qo, say) {
    var info = rowInfo(row), r = normalize(info, want, qo), inp = row.querySelector('.qol-qty'), cap = row.querySelector('[data-bz-cap]');
    if (inp) inp.value = r.q;
    if (cap) { cap.textContent = r.msg; cap.hidden = !r.msg; }
    syncQo(qo);
    if (say) announce((row.getAttribute('data-label') || '') + ': ' + r.q + '.' + (r.msg ? ' ' + r.msg : ''));
  }
  function cartSync(qo, cart) {
    var map = {};
    (cart && cart.items || []).forEach(function (it) { map[it.variant_id] = (map[it.variant_id] || 0) + it.quantity; });
    $$('[data-bz-row]', qo).forEach(function (row) {
      var id = row.getAttribute('data-id'), c = map[id] || 0, note = row.querySelector('[data-bz-incart]');
      row.setAttribute('data-cart', c);
      if (c && qo.getAttribute('data-in-cart')) {
        if (!note) { note = D.createElement('span'); note.className = 'qol-cap'; note.setAttribute('data-bz-incart', ''); var info = row.querySelector('.qo-info'); if (info) info.appendChild(note); }
        note.textContent = fill(qo.getAttribute('data-in-cart'), { n: c }); note.hidden = false;
      } else if (note) { note.hidden = true; }
    });
    syncQo(qo);
  }
  function loadCart() {
    return fetch(root() + 'cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); });
  }
  function initQo(qo) {
    if (qo._bz) return; qo._bz = true;
    qo.addEventListener('click', function (e) {
      var st = e.target.closest && e.target.closest('[data-bzstep]');
      if (st) {
        e.preventDefault();
        if (st.getAttribute('aria-disabled') === 'true') return;
        var row = st.closest('[data-bz-row]'), info = rowInfo(row), inp = row.querySelector('.qol-qty'), q = Math.max(0, parseInt(inp.value, 10) || 0), d = +st.getAttribute('data-bzstep');
        var want;
        if (d > 0) want = nextUp(info, q);
        else { want = q - info.inc; if (info.cart + want < info.min) want = 0; }
        setRow(row, want, qo, true);
        return;
      }
      var add = e.target.closest && e.target.closest('[data-bz-addall]');
      if (add) {
        e.preventDefault();
        var items = [], rows = [];
        $$('[data-bz-row]', qo).forEach(function (row) {
          var inp = row.querySelector('.qol-qty'), q = Math.max(0, parseInt(inp && inp.value, 10) || 0);
          if (q) { items.push({ id: rowInfo(row).id, quantity: q }); rows.push(row); }
        });
        if (!items.length) return;
        var msg = qo.querySelector('[data-bz-qo-msg]');
        add.disabled = true; add.classList.add('loading');
        if (msg) { msg.hidden = true; msg.textContent = ''; }
        addToCart(items).then(function () {
          rows.forEach(function (row) { var inp = row.querySelector('.qol-qty'); if (inp) inp.value = 0; var cap = row.querySelector('[data-bz-cap]'); if (cap) cap.hidden = true; });
          announce(qo.getAttribute('data-added') || '');
          return loadCart().then(function (cart) { cartSync(qo, cart); });
        }).catch(function (err) {
          var t = errText(err, qo.getAttribute('data-err'));
          if (msg) { msg.textContent = t; msg.hidden = false; }
          announce(t);
        }).then(function () { add.classList.remove('loading'); syncQo(qo); });
      }
    });
    qo.addEventListener('change', function (e) {
      var inp = e.target; if (!inp.classList || !inp.classList.contains('qol-qty')) return;
      setRow(inp.closest('[data-bz-row]'), inp.value, qo, true);
    });
    qo.addEventListener('input', function (e) {
      var inp = e.target; if (!inp.classList || !inp.classList.contains('qol-qty')) return;
      syncQo(qo);
    });
    qo.addEventListener('keydown', function (e) {
      var inp = e.target; if (e.key !== 'Enter' || !inp.classList || !inp.classList.contains('qol-qty')) return;
      e.preventDefault(); setRow(inp.closest('[data-bz-row]'), inp.value, qo, true);
    });
    syncQo(qo);
    loadCart().then(function (cart) { cartSync(qo, cart); }).catch(function () {});
  }
  /* Winkelwagen elders aangepast (Slide Cart, snel toevoegen): aantallen "al in je winkelwagen" bijwerken */
  D.addEventListener('cart:refresh', function (e) {
    var cart = e.detail && e.detail.cart; if (!cart) return;
    $$('.qol[data-bz-qo]').forEach(function (qo) { cartSync(qo, cart); });
  });

  /* ---------- Opnieuw bestellen ---------- */
  D.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('[data-bz-reorder]'); if (!b) return;
    e.preventDefault(); if (b.disabled) return;
    var items = [];
    try { items = JSON.parse(b.getAttribute('data-bz-reorder')) || []; } catch (x) { items = []; }
    if (!items.length) return;
    /* Zichtbare melding onder de knop (niet alleen voor schermlezers), zoals de toast in de demo */
    var order = b.closest('.bz-order'), box = order && order.querySelector('[data-bz-reorder-msg]');
    function show(t, isErr) {
      if (box) { box.textContent = t; box.hidden = !t; box.classList.toggle('is-err', !!isErr); }
      if (t) announce(t);
    }
    show('', false);
    b.disabled = true; b.classList.add('loading');
    addToCart(items).then(function () {
      var ok = b.getAttribute('data-ok') || '', skip = b.getAttribute('data-skip') || '';
      show(ok + (ok && skip ? ' ' : '') + skip, false);
    })
      .catch(function (err) { show(errText(err, b.getAttribute('data-err')), true); })
      .then(function () { b.disabled = false; b.classList.remove('loading'); });
  });

  /* ---------- Starten (ook na herladen van een sectie in de thema-editor) ---------- */
  function init(r) {
    $$('form[data-bz-apply]', r).forEach(initApply);
    $$('[data-bz-done]', r).forEach(initDone);
    $$('.qol[data-bz-qo]', r).forEach(initQo);
  }
  init(D);
  D.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
